import * as React from 'react'
import { HeaderCollege } from '../../molecules/header-college/header-college'
import { FormCollege } from '../../molecules/form-college/form-college'
import { HowToWin } from '../../molecules/how-to-win/how-to-win'
import { Rewards } from '../../molecules/rewards/rewards'
import { FrequentlyQuestions } from '../../molecules/frequently-questions/frequently-questions'
import './home-page.scss'

export const HomePage = () => {
  return (
    <div className="f-home-page">
      <HeaderCollege />

      <FormCollege />

      <HowToWin />

      <Rewards />

      <FrequentlyQuestions />
    </div>
  )
}
